import { toNumber } from 'lodash';
import { useEffect, useState } from 'react';
import { type Layout } from 'react-grid-layout';
import { useGetLayoutScreens } from 'src/hooks';
import { useGlobalComponentsScreen } from 'src/hooks/useGlobalComponentsScreen';

import { useCreateLayoutsPage } from '../../createSectionsLayoutsPage/hooks/useCreateLayoutsPage.hook';

export const useCreateRotationLayoutsPage = (
  layoutId: number,
  screenIndex: number,
) => {
  const { data: layouts = [] } = useGetLayoutScreens(
    layoutId,
    Boolean(layoutId),
  );
  const globalComponentsScreen = useGlobalComponentsScreen(layouts?.[0]);

  const {
    rows,
    cols,
    gridHeight,
    screenWidth,
    gridSectionHeight,
    gridSectionWidth,
    extraHeightForDisclaimerTopAdjustment,
  } = useCreateLayoutsPage(toNumber(layoutId), toNumber(screenIndex), true);

  const [rotationGridSections, setRotationGridSections] = useState<Layout[]>(
    [],
  );

  useEffect(() => {
    const defaultRotationSections = layouts?.[0]?.screens[
      screenIndex - 1
    ]?.sections
      ?.filter((section) => section?.config?.events?.SECTION_TIMER)
      ?.map((section, index) => {
        return {
          h: Math.round(section.height / (gridHeight / rows)),
          w: Math.round(section.width / (screenWidth / cols)),
          x: Math.round((section.left_offset * cols) / screenWidth),
          y: Math.round(
            ((section.top_offset - extraHeightForDisclaimerTopAdjustment) *
              rows) /
              gridHeight,
          ),
          i: `${index}`,
        };
      });
    if (defaultRotationSections) {
      setRotationGridSections(defaultRotationSections);
    }
  }, [
    layouts,
    screenIndex,
    gridHeight,
    rows,
    screenWidth,
    cols,
    extraHeightForDisclaimerTopAdjustment,
  ]);

  return {
    rotationGridSections,
    setRotationGridSections,
    gridSectionHeight,
    gridSectionWidth,
    globalComponentsScreen,
  };
};
